import { Modal } from '@mui/material';
import { useContext } from 'react';
import { setCookie } from '../../common/func/cookieFunc';
import { AppContext } from '../../context/AppContext';

export default function Notice() {
	const { noticeOpen, setNoticeOpen } = useContext(AppContext);

	const modalAddCookie = () => {
		const expireDate = new Date();
		expireDate.setDate(expireDate.getDate() + 7);
		setCookie('NoticeModalNoMoreView', true, expireDate);
		setNoticeOpen(false);
	};

	return (
		<Modal open={noticeOpen} onClose={() => setNoticeOpen(false)}>
			{/* <!-- 기획의도 모달 팝업 --> */}
			<section className="NoticeModalSection" tabIndex="-1">
				<div className="NoticeModalPaper">
					<button
						className="CloseIconButton"
						onClick={() => setNoticeOpen(false)}
					>
						<img src="img/popCloseBtn.png" alt="닫기" />
					</button>
					<div className="NoticeModalPaperContent">
						<div className="HeadingBox">
							<h3 className="text-heading-lg">
								유입‧유출 중심성 지수로 알아보는 우리 지역 거점
							</h3>
							<h4 className="text-heading-md">
								자택-직장 주소 OD를 활용한 거점 분석
							</h4>
						</div>
						<div className="Content">
							"인구/고용 집적도 분석으로 찾아보는 지역발전 전략의 구심점: 우리
							지역의 거점은 어디일까?"에서 제시한 대로 '콤팩트-네트워크'(compact
							& network) 공간발전 전략의 필요성이 나날이 커지고 있습니다.
							콤팩트-네트워크 전략은 국토공간에서 심화되고 있는 인구감소,
							고령화, 과소화, 지역소멸 위험 등에 대응하기 위해, 거주인구,
							근무인구를 비롯하여 다양한 활동 인구가 집적해 있는 장소인
							'거점'(center)을 집중적으로 육성하고, 거점과 주변 간의 교통 연계를
							유지‧강화하고자 하는 것입니다.
							<br />
							<br />
							인구감소시대 콤팩트-네트워크 공간발전 전략을 지원하기 위해,
							국토공간 상의 '거점'을 탐색적으로 살펴볼 수 있는 도구를
							개발하였습니다. "인구/고용 집적도 분석으로 찾아보는 지역발전
							전략의 구심점: 우리 지역의 거점은 어디일까?"에서는 거점 분석을
							위한 '밀도 접근'에 해당하는 분석 도구를 제시하였습니다. 그런데
							이번 "자택-직장 주소 OD를 활용한 거점 분석: 유입·유출 중심성
							지수로 알아보는 우리 지역 거점"에서 제시하는 도구는 거점 분석을
							위한 "상호작용 접근"에 해당합니다.
							<br />
							<br />
							'밀도 접근'은 공간상에서의 사람들의 다양한 활동과 연결되는
							'거주인구, 일자리, 각종 시설, 토지이용' 등이 '(고밀도로) 집적해
							있는 장소', 즉 '집적지'(agglomeration)를 일차적으로 식별하고,
							식별한 집적지를 대상으로 '거점'(center)을 추출합니다. 밀도
							접근에서 '거점'은 주변으로부터 사람들의 통행을 끌어들이거나
							주변으로 내보낼 가능성이 높을 정도로 거주인구, 근무인구 등 다양한
							활동 인구가 상대적으로 집중‧집적되어 있으며, 그에 따라
							'다기능‧복합화', '집적‧규모의 경제'가 실현될 가능성도 높은 장소가
							됩니다. <br />
							<br />
							'상호작용 접근'은 실제로 사람들의 통행을 끌어들이거나 내보냄으로써
							주변 노드(들)에 의미 있게 영향을 가하는 장소인 거점에 대한 분석에
							초점을 맞춥니다. 특정 노드가 통행을 끌어들이거나 내보냄으로써 다른
							노드(들)에 가하는 영향력의 크기는 '유입 중심성 지수'와 '유출
							중심성 지수'로 분석할 수 있습니다. <br />
							<br />
							이번 "자택-직장 주소 OD를 활용한 거점 분석: 유입·유출 중심성
							지수로 알아보는 우리 지역 거점"에서는, 구체적으로 격자를
							단위공간으로 하는 '자택 주소-직장 주소 OD'(origin-destination)
							매트릭스 데이터를 활용하는데, OD 매트릭스 상의 노드인 격자 각각을
							대상으로 '유입 중심성 지수'와 '유출 중심성 지수'를 산출하였습니다.
							그리고 중심성 지수 값에 사용자가 원하는 수치를 직접 입력하거나
							조정함으로써 '유입 중심성 거점' 및 '유출 중심성 거점'을 살펴볼 수
							있도록 하였습니다. 또한 사용자 조건을 만족하는 '유입 중심성
							거점'과 '유출 중심성 거점' 간의 교집합인 '유입+유출 거점'으로
							추출하는 기능도 제공합니다. 무엇보다도 이러한 '유입+유출 거점'이
							'상호작용 접근'에서 분석하고자 하는 거점에 부합합니다. <br />
							<br />
							분석에 활용한 데이터는 KCB(Korea Credit Bureau)의 1kmX1km 격자
							단위 자택주소지와 직장주소지로 구성된 OD 데이터(2021년 기준)로,
							해당 OD를 출근 통행 OD로 가정하고, 이를 대상으로 '유입·유출 중심성
							지수'를 산출하였습니다. <br />
							<br />
						</div>

						<div className="dataSourceTable">
							<table>
								<thead>
									<tr>
										<th>구분</th>
										<th>데이터</th>
										<th>기준년도</th>
										<th>출처</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>유입‧유출 중심성 지수</td>
										<td>1kmX1km 격자 단위 OD(자택 주소지-직장 주소지)</td>
										<td>2021년</td>
										<td>KCB</td>
									</tr>
									<tr>
										<td>거주인구</td>
										<td>1kmX1km 격자 단위 인구주택 총조사 인구</td>
										<td>2021년</td>
										<td>SGIS(통계청)</td>
									</tr>
									<tr>
										<td>근무인구</td>
										<td>1kmX1km 격자 단위 직장 주소지 기준 인구</td>
										<td>2021년</td>
										<td>KCB</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="Content">
							<li>
								<span className="bold">작성 및 문의: </span>국토연구원 이영민
								부연구위원(ymlee@krihs.re.kr), 변필성
								선임연구위원(drbyun@krihs.re.kr)
							</li>
							<li>
								<span className="bold">작성연월: </span>2023년 5월
							</li>
						</div>
					</div>

					<footer className="NoticeModalFooter">
						<div className="AddCookieBox">
							<div className="AddCookieButton" onClick={modalAddCookie}>
								<img src="img/popCloseBottomBtn.png" alt="일주일간 보지않기" />
								<span>일주일간 보지않기</span>
							</div>
						</div>
					</footer>
				</div>
			</section>
		</Modal>
	);
}
